import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import numeral from 'numeral';
import { withTranslation } from 'react-i18next';
import { IconSize } from '../../../Icons/IconWrap';
import UserAvatar from '../../../User/Avatar';
import UserIcon from '../../../Icons/User';
import CoreIconSmall from '../../../Icons/CoreIconSmall';
import StandardMenu from '../../../Dropdown/Preset/StandardMenu';
import { URLS } from '@wix/da-url/dist/src/constants';
import { Url } from '@wix/da-url';
import MatureToggle from '../../../MatureToggle';
import ThemeToggle from '../../_partials/ThemeToggle';
import LogoutItem from '../../_partials/LogoutItem';
import FeedbackIcon from '../../../Icons/Feedback';
import UserLink from '../../../User/Link';
import VerificationReminder from '../../_partials/VerificationReminder';
import { BiEventType, ReferralType } from '../../../biLogger/constants';
import shortenNumber from '../../../utils/shortenNumber';
import { ThemeOverride } from '../../../Context';
import { ThemeOptions } from '../../../publicSession';
import Eye from '../../../Icons/Eye';
import Pencil from '../../../Icons/Pencil';
import Button from '../../../Button';
import { compose } from 'redux';
import { withFeatureFlags } from '../../../redux/flags';
import PlainButtonOrLink from '../../../Button/PlainButtonOrLink';
import siteHeaderStyles from '../SiteHeaderMobile.scss';
import s from './UserMenu.scss';
var UserMenu = /** @class */ (function (_super) {
    __extends(UserMenu, _super);
    function UserMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.logoutItemRef = React.createRef();
        _this.toggleUserMenu = function (flag) {
            var newState = flag !== undefined ? flag : !_this.state.isUserMenuOpened;
            if (document && document.documentElement) {
                // Prevent scrolling when menu is open
                if (newState) {
                    document.body.style.overflow = 'hidden';
                    document.documentElement.style.overflow = 'hidden';
                    document.documentElement.style.height = '100%';
                    document.documentElement.style.position = 'relative';
                }
                else {
                    document.body.style.overflow = 'auto';
                    document.documentElement.style.overflow = 'auto';
                    document.documentElement.style.height = 'initial';
                    document.documentElement.style.position = 'initial';
                }
            }
            if (!_this.state.isUserMenuOpened && _this.props.onOpen) {
                _this.props.onOpen();
            }
            _this.setState({ isUserMenuOpened: newState });
        };
        _this.handleLogout = function () {
            _this.logoutItemRef &&
                _this.logoutItemRef.current &&
                _this.logoutItemRef.current.submit();
        };
        _this.getBuyCore = function () {
            var _a = _this.props, t = _a.t, hasCoreMembership = _a.hasCoreMembership;
            return {
                label: (React.createElement("div", { className: classnames(s['two-side-label'], s['buy-core-label']) },
                    React.createElement("span", null, hasCoreMembership
                        ? t('siteHeaderMobile.userMenu.extendCore')
                        : t('siteHeaderMobile.userMenu.buyCoreMembership')),
                    React.createElement("span", null,
                        React.createElement(CoreIconSmall, { className: s['core-icon'] })))),
                link: URLS.CORE_MEMBERSHIP,
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    menu_item: 'coreMembership',
                    menu_name: 'profile',
                    link_url: URLS.CORE_MEMBERSHIP,
                },
            };
        };
        _this.getMatureToggleItem = function () {
            var _a = _this.props, t = _a.t, _b = _a.matureContent, matureContent = _b === void 0 ? false : _b, toggleMature = _a.toggleMature;
            return {
                label: (React.createElement("div", { className: classnames(s['mature-label'], s['two-side-label']) },
                    React.createElement("span", { onClick: function () { return toggleMature(matureContent); } }, t('siteHeaderMobile.userMenu.matureContent')),
                    React.createElement(MatureToggle, { className: classnames(s['mature-toggle'], matureContent && s['checked']), forcedLightTheme: true, checked: matureContent, onChange: toggleMature }))),
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    menu_item: 'toggle_mature',
                    menu_name: 'profile',
                    toggle_value: !matureContent ? 'mature_on' : 'mature_off',
                },
            };
        };
        _this.getWixPortfolio = function () {
            var _a = _this.props, t = _a.t, hasWixPortfolio = _a.hasWixPortfolio, pushWixPortfolioModal = _a.pushWixPortfolioModal, flags = _a.flags, isLegacyHeader = _a.isLegacyHeader;
            var createPortfolio = pushWixPortfolioModal;
            if (isLegacyHeader) {
                var url_1 = Url.browseHomeLink() + "?submit_modal=portfolio";
                createPortfolio = function () {
                    window.location.assign(url_1);
                };
            }
            return {
                label: (React.createElement("div", { className: s['portfolio-label'] },
                    React.createElement(PlainButtonOrLink, { className: s['portfolio-text'], onClick: hasWixPortfolio && !flags.includes('wix_portfolio_allow_recreate')
                            ? undefined
                            : createPortfolio, href: hasWixPortfolio && !flags.includes('wix_portfolio_allow_recreate')
                            ? '/wixsite/edit'
                            : undefined }, t('siteHeader.userMenu.wixPortfolio.portfolio')),
                    React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT }, hasWixPortfolio &&
                        !flags.includes('wix_portfolio_allow_recreate') ? (React.createElement(React.Fragment, null,
                        React.createElement("a", { className: s['portfolio-button'], href: "/wixsite/view", target: "_blank" },
                            React.createElement(Eye, { disableDefaultColors: true })),
                        React.createElement("a", { className: s['portfolio-button'], href: "/wixsite/edit", target: "_blank" },
                            React.createElement(Pencil, { disableDefaultColors: true })))) : (React.createElement(Button, { view: "b3", onClick: createPortfolio, className: s['portfolio-create-button'], biData: {
                            evid: BiEventType.WIX_PORTFOLIO_CREATE_CLICK,
                            sectionname: 'usermenu',
                        } }, t('siteHeader.userMenu.wixPortfolio.create')))))),
            };
        };
        _this.getThemeSwitcherIfApplicable = function () {
            var _a = _this.props, t = _a.t, toggleTheme = _a.toggleTheme, disableThemeSwitcher = _a.disableThemeSwitcher, theme = _a.theme;
            if (disableThemeSwitcher) {
                return null;
            }
            return {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", null, t('siteHeaderMobile.userMenu.mode')),
                    React.createElement(ThemeToggle, { className: s['theme-toggle'] }))),
                onClick: function () { return toggleTheme(); },
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    menu_item: 'toggle_theme',
                    menu_name: 'profile',
                    toggle_value: theme === 'light' ? 'dark' : 'light',
                },
            };
        };
        _this.getFeedback = function () {
            var _a = _this.props, t = _a.t, feedbackUrl = _a.feedbackUrl;
            if (!feedbackUrl) {
                return null;
            }
            return {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", null, t('siteHeaderMobile.userMenu.giveUsFeedback')),
                    React.createElement(FeedbackIcon, { className: s['feedback-icon'] }))),
                link: feedbackUrl,
                target: '_blank',
            };
        };
        _this.handleToggle = function () {
            _this.toggleUserMenu();
        };
        _this.state = {
            isUserMenuOpened: Boolean(props.isOpen),
        };
        return _this;
    }
    UserMenu.prototype.componentDidUpdate = function (prevProps) {
        var isOpen = this.props.isOpen;
        var isOpenChanged = prevProps.isOpen !== isOpen;
        if (isOpenChanged && this.state.isUserMenuOpened !== isOpen) {
            this.setState({
                isUserMenuOpened: Boolean(isOpen),
            });
        }
    };
    UserMenu.prototype.formatNumber = function (number) {
        return number > 999 ? shortenNumber(number, 0, Math.floor) : number;
    };
    UserMenu.prototype.renderNotificationCountBadge = function () {
        var _a = this.props, noteCount = _a.noteCount, feedbackCount = _a.feedbackCount, hideNotificationCount = _a.hideNotificationCount;
        var notificationsCount = noteCount + feedbackCount;
        return hideNotificationCount || notificationsCount === 0 ? null : (React.createElement("span", { className: siteHeaderStyles['number-label__red'] },
            React.createElement("span", { className: classnames(siteHeaderStyles['number'], s['notification']) }, this.formatNumber(notificationsCount))));
    };
    UserMenu.prototype.renderAvatarPart = function () {
        var _a = this.props, currentUser = _a.currentUser, isLoggedIn = _a.isLoggedIn;
        var isUserMenuOpened = this.state.isUserMenuOpened;
        return (React.createElement(React.Fragment, null,
            isLoggedIn && (React.createElement("div", { onClick: this.handleToggle, className: classnames(s['avatar-wrapper'], isUserMenuOpened && s['with-menu-open']) },
                React.createElement(UserAvatar, { user: currentUser, className: s['avatar'], withLink: false, withTooltip: false }),
                !isUserMenuOpened && this.renderNotificationCountBadge())),
            !isLoggedIn && (React.createElement("div", { onClick: this.handleToggle, className: classnames(s['avatar-wrapper'], isUserMenuOpened && s['with-menu-open']) },
                React.createElement(UserIcon, { className: classnames(s['anon-user-icon'], this.state.isUserMenuOpened && s['is-dark']), size: IconSize.MEDIUM, withPadding: true })))));
    };
    UserMenu.prototype.renderLoggedInMenu = function () {
        var _a = this.props, t = _a.t, currentUser = _a.currentUser, pointsCount = _a.pointsCount, noteCount = _a.noteCount, csrfToken = _a.csrfToken, canEnableMatureContent = _a.canEnableMatureContent, flags = _a.flags, verificationEmail = _a.verificationEmail;
        var personalGroupItems = [
            {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", null, t('siteHeaderMobile.userMenu.notes')),
                    noteCount > 0 && (React.createElement("span", { className: s['menu-item-notification'] }, this.formatNumber(noteCount))))),
                link: URLS.NOTES,
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    link_url: URLS.NOTES,
                    menu_item: 'notes',
                    menu_name: 'profile',
                },
            },
            {
                label: 'Sta.sh',
                link: URLS.STASH,
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    menu_item: 'sta.sh',
                    menu_name: 'profile',
                    link_url: URLS.STASH,
                },
            },
            flags.includes('wix_portfolio') && this.getWixPortfolio(),
        ];
        var statsGroupItems = [
            {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", null, t('siteHeaderMobile.userMenu.pointsBalance')),
                    React.createElement("span", null, numeral(pointsCount || 0).format('0,0')))),
                link: URLS.POINTS,
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    menu_item: 'pointsBalance',
                    menu_name: 'profile',
                    link_url: URLS.POINTS,
                },
            },
            {
                label: t('siteHeaderMobile.userMenu.myEarnings'),
                link: URLS.EARNINGS,
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    menu_item: 'myEarnings',
                    menu_name: 'profile',
                    link_url: URLS.EARNINGS,
                },
            },
            {
                label: t('siteHeaderMobile.userMenu.myOrderHistory'),
                link: URLS.ORDERS,
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    menu_item: 'orderHistory',
                    menu_name: 'profile',
                    link_url: URLS.ORDERS,
                },
            },
        ];
        var lastGroupItems = [
            this.getThemeSwitcherIfApplicable(),
            canEnableMatureContent && this.getMatureToggleItem(),
            {
                label: t('siteHeaderMobile.userMenu.settings'),
                link: URLS.SETTINGS,
                className: s['settings-link'],
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    link_url: URLS.SETTINGS,
                    menu_item: 'settings',
                    menu_name: 'profile',
                },
            },
            {
                label: (React.createElement(LogoutItem, { formRef: this.logoutItemRef, token: csrfToken, label: t('siteHeaderMobile.userMenu.logOut') })),
                onClick: this.handleLogout,
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    link_url: URLS.LOGOUT,
                    menu_item: 'logout',
                    menu_name: 'profile',
                },
            },
            this.getFeedback(),
        ].filter(function (item) { return item; });
        return (React.createElement(StandardMenu, { lightText: true, className: s['user-menu'], itemClassName: s['user-menu-item'], groupClassName: s['user-menu-group'], withPaddings: false, items: [
                {
                    className: s['top-group'],
                    items: [
                        {
                            label: (React.createElement("div", { className: s['two-side-label'] },
                                React.createElement(UserLink, { user: currentUser, className: s['user-link'], showSymbol: false }),
                                this.renderAvatarPart())),
                        },
                        this.getBuyCore(),
                    ],
                },
                !verificationEmail && {
                    className: s['group'],
                    items: personalGroupItems,
                },
                verificationEmail
                    ? {
                        label: React.createElement(VerificationReminder, { email: verificationEmail }),
                        className: s['verification-group'],
                    }
                    : {
                        className: s['group'],
                        items: statsGroupItems,
                    },
                {
                    className: s['group'],
                    items: lastGroupItems,
                },
            ] }));
    };
    UserMenu.prototype.renderLoggedOutMenu = function () {
        var t = this.props.t;
        var items = [
            {
                className: s['top-group'],
                items: [
                    {
                        label: (React.createElement("div", { className: s['two-side-label'] },
                            React.createElement("span", { className: s['anon-hello'] }, t('siteHeaderMobile.userMenu.hello')),
                            this.renderAvatarPart())),
                    },
                ],
            },
            {
                className: s['group'],
                items: [
                    {
                        label: t('siteHeaderMobile.userMenu.signIn'),
                        link: Url.loginLink(),
                        biData: {
                            evid: BiEventType.TOP_NAV_MENU_CLICK,
                            link_url: Url.loginLink(),
                            menu_item: 'login',
                            menu_name: 'profile',
                        },
                    },
                    {
                        label: t('siteHeaderMobile.userMenu.join'),
                        link: Url.joinLink(),
                        biData: {
                            evid: BiEventType.REDIRECT_TO_LOGIN,
                            referral_info: ReferralType.HEADER,
                        },
                    },
                    {
                        label: (React.createElement("div", { className: classnames(s['two-side-label'], s['buy-core-label']) },
                            React.createElement("span", null, t('siteHeaderMobile.userMenu.buyCoreMembership')),
                            React.createElement("span", null,
                                React.createElement(CoreIconSmall, { className: s['core-icon'] })))),
                        link: URLS.CORE_MEMBERSHIP,
                    },
                    this.getThemeSwitcherIfApplicable(),
                    this.getMatureToggleItem(),
                ],
            },
        ].filter(function (item) { return item; });
        return (React.createElement(StandardMenu, { lightText: true, className: s['user-menu'], itemClassName: s['user-menu-item'], groupClassName: s['user-menu-group'], items: items }));
    };
    UserMenu.prototype.render = function () {
        var isLoggedIn = this.props.isLoggedIn;
        var isUserMenuOpened = this.state.isUserMenuOpened;
        return (React.createElement("div", { className: s['user-menu-wrapper'] },
            !this.state.isUserMenuOpened && this.renderAvatarPart(),
            React.createElement("div", { className: classnames(s['user-menu-shade'], isUserMenuOpened && s['is-active']), 
                // Since react-onclickoutside wasn't really working for this component and my most
                // valiant efforts to make it do so were met with failure, just do it ourselves
                onTouchStart: this.handleToggle, onClick: this.handleToggle }),
            React.createElement("div", { className: classnames(s['user-menu-list-wrapper'], isUserMenuOpened && s['is-opened']) },
                isLoggedIn && this.renderLoggedInMenu(),
                !isLoggedIn && this.renderLoggedOutMenu())));
    };
    return UserMenu;
}(React.Component));
export { UserMenu };
var enhance = compose(withTranslation(), withFeatureFlags);
export default enhance(UserMenu);
//# sourceMappingURL=UserMenu.js.map